/** student/endorsement-tags — HOOKS. Static reference data → cached indefinitely. */
import { useQuery } from '@tanstack/react-query';
import { studentEndorsementTagsApi } from './api';
import { studentEndorsementTagsKeys } from './keys';

export function useEndorsementTags() {
  return useQuery({
    queryKey: studentEndorsementTagsKeys.all(),
    queryFn: () => studentEndorsementTagsApi.list(),
    staleTime: Infinity,
  });
}
